/**
 * Keep routes supplied by API payloads inside Audit Pro.
 *
 * React Router accepts string destinations, so a protocol-relative path or a
 * backslash-normalised path must never be passed to navigate/Link directly.
 */
export function safeInternalRoute(value, fallback = '/') {
  if (typeof value !== 'string') return fallback;
  const route = value.trim();
  if (!route || !route.startsWith('/') || route.startsWith('//')) return fallback;
  if (/[\\\u0000-\u001f\u007f]/.test(route)) return fallback;

  try {
    const decoded = decodeURIComponent(route);
    if (!decoded.startsWith('/') || decoded.startsWith('//') || decoded.includes('\\')) return fallback;
  } catch {
    return fallback;
  }

  return route;
}
